export const SOCIALS = {
  telegram: 'https://t.me/iam_nikitka',
  instagram: 'https://www.instagram.com/iam_nikitka/',
  tiktok: 'https://www.tiktok.com/@iam_nikitka',
};
